import { actionClearCanvas } from "../actions";
import { atom, useAtom, useSetAtom } from "../editor-jotai";
import { t } from "../i18n";

import { useExcalidrawActionManager } from "./App";
import ConfirmDialog from "./ConfirmDialog";
import {
  isFloatingLibraryOpenAtom,
  isLibraryMenuOpenAtom,
} from "./LibraryMenu";

export const activeConfirmDialogAtom = atom<"clearCanvas" | null>(null);

export const ActiveConfirmDialog = () => {
  const [activeConfirmDialog, setActiveConfirmDialog] = useAtom(
    activeConfirmDialogAtom,
  );
  const actionManager = useExcalidrawActionManager();
  const setIsFloatingLibraryOpen = useSetAtom(isFloatingLibraryOpenAtom);
  const setIsLibraryMenuOpen = useSetAtom(isLibraryMenuOpenAtom);

  if (!activeConfirmDialog) {
    return null;
  }

  if (activeConfirmDialog === "clearCanvas") {
    return (
      <ConfirmDialog
        onConfirm={() => {
          // Close both library states before clearing canvas
          setIsFloatingLibraryOpen(false);
          setIsLibraryMenuOpen(false);
          actionManager.executeAction(actionClearCanvas);
          setActiveConfirmDialog(null);
        }}
        onCancel={() => setActiveConfirmDialog(null)}
        title={t("clearCanvasDialog.title")}
      >
        <p className="clear-canvas__content"> {t("alerts.clearReset")}</p>
      </ConfirmDialog>
    );
  }

  return null;
};
